<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>
    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Opciones para tu solicitud</h1>
    </div>
  </div>

  <!-- Sections -->
  <div class="row-cols-12 m-2 mt-0">
    <div class="row mt-0">
      <div class="col">
        <div class="text-p p-3 pt-0 locationUser">
          Para continuar toca la fecha y hora del profesional que elijas
        </div>
      </div>
    </div>

    @if (ordenesPrestador()[0]?.x_img_receta) {
      <div class="row mt-0">
        <div class="col">
          <span class="ps-3 pe-0" title="Descargar Receta" style="cursor:pointer;" (click)="openFile()">
            <i class="bi bi-file-earmark-text"></i><span> Receta</span>
          </span>
        </div>
      </div>
    }

    <div class="row-cols-12 mt-0">
      <div class="mt-0">
        @for (orderPrestador of ordenesPrestador(); track trackByOrden($index, orderPrestador)) {
          <div class="row m-3">
            <div
              class="col-3 col-sm-2 col-lg-1 prestador prest1 p-0"
              [routerLink]="['/perfil-prestador/' + orderPrestador.id_prestador]">
              <img [src]="orderPrestador.imgAvatarPrestador ? API_URI + 'uploads/images/small-' + orderPrestador.imgAvatarPrestador : './assets/img/profesional-init.png'">
            </div>

            <div
              class="row col-9 col-sm-10 col-lg-11"
              style="padding-right: 0; cursor: pointer;"
              [routerLink]="['/perfil-prestador/' + orderPrestador.id_prestador]">

              <div class="col-8">
                <div class="pt-0 nameUser text-truncate">
                  {{ orderPrestador.nombrePrestador }}
                </div>
                <div class="pt-0 price text-truncate">
                  <b>{{ orderPrestador.n_precio_turno | currency:'ARS' }}</b>/consulta
                </div>
              </div>

              <div class="col-4 pt-2 p-0">
                <i class="bi bi-star bistarnf" style="color: #205EA5;float:right;"></i>
                <i class="bi bi-star-fill bistar" style="color: #205EA5;float:right;"></i>
                <i class="bi bi-star-fill bistar" style="color: #205EA5;float:right;"></i>
                <i class="bi bi-star-fill bistar" style="color: #205EA5;float:right;"></i>
                <i class="bi bi-star-fill bistar" style="color: #000;float:right;"></i>
              </div>

              <div class="col-auto">
                <div class="pt-0 locationUser">
                  {{ orderPrestador.nombrePrestacion }}
                </div>
              </div>
            </div>

            <div class="col mt-3">
              <div class="row mt-1">
                <div class="col-4 btn-opt-global text-center">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg mt-0 btnOpt"
                    [disabled]="loadingLocal() || loadingGlobal()"
                    (click)="pagarOrderPrestador(orderPrestador, orderPrestador.d_fecha_uno_prestador)">
                    {{ (loadingLocal() || loadingGlobal()) ? 'Cargando...' : ((orderPrestador.d_fecha_uno_prestador | date: 'dd/MM/yyyy HH:mm') + ' hs.') }}
                  </button>
                </div>

                <div class="col-4 btn-opt-global text-center">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg mt-0 btnOpt"
                    [disabled]="loadingLocal() || loadingGlobal()"
                    (click)="pagarOrderPrestador(orderPrestador, orderPrestador.d_fecha_dos_prestador)">
                    {{ (loadingLocal() || loadingGlobal()) ? 'Cargando...' : ((orderPrestador.d_fecha_dos_prestador | date: 'dd/MM/yyyy HH:mm') + ' hs.') }}
                  </button>
                </div>

                <div class="col-4 btn-opt-global text-center">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg mt-0 btnOpt"
                    [disabled]="loadingLocal() || loadingGlobal()"
                    (click)="pagarOrderPrestador(orderPrestador, orderPrestador.d_fecha_tres_prestador)">
                    {{ (loadingLocal() || loadingGlobal()) ? 'Cargando...' : ((orderPrestador.d_fecha_tres_prestador | date: 'dd/MM/yyyy HH:mm') + ' hs.') }}
                  </button>
                </div>
              </div>
            </div>

            @if ($index < ordenesPrestador().length - 1) {
              <hr class="divisor mt-4 mb-4">
            }
          </div>
        }
      </div>
    </div>

    @if (error()) {
      <div class="alert alert-danger mt-2" role="alert">
        <small>{{ error() }}</small>
      </div>
      <div class="col d-flex justify-content-evenly">
        <button type="button" class="btn btn-primary btn-lg mt-0 btnOpt btn-help fade-in p-2" [routerLink]="['/ayuda']">
          Ayuda
        </button>
      </div>
    }
  </div>
</div>